/* ============================================================
   USP Showcase — behavior

   Same stagger-in technique already used by Lifestyle Showcase
   and Footer Signup: everything targeted below is hidden by CSS
   until this section carries [data-in-view="true"], which an
   IntersectionObserver toggles on/off as the section enters and
   leaves the viewport — so the animation replays every time,
   not just once on page load. The product image shares the same
   trigger (its own, larger-offset CSS transition handles the
   "floating up" look) so everything reveals together in one
   scroll-triggered moment, no second observer needed.
   ============================================================ */

(function () {
  'use strict';

  function initStagger(section) {
    var eyebrow = section.querySelector('[data-usp-intro]');
    var words = Array.prototype.slice.call(section.querySelectorAll('[data-usp-word]'));
    var body = section.querySelector('[data-usp-fade].usp-showcase__body');
    var rows = Array.prototype.slice.call(section.querySelectorAll('[data-usp-row]'));

    var i = 0;
    if (eyebrow) eyebrow.style.setProperty('--i', i++);
    words.forEach(function (w) {
      w.style.setProperty('--i', i++);
    });
    if (body) body.style.setProperty('--i', i++);
    rows.forEach(function (r) {
      r.style.setProperty('--i', i++);
    });

    var introEnabled = section.dataset.introAnimate === 'true';
    var floatEnabled = section.dataset.productFloat === 'true';

    if (!introEnabled && !floatEnabled) return;

    if (!('IntersectionObserver' in window)) {
      section.setAttribute('data-in-view', 'true');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            /* Two animation frames before revealing: flipping the
               attribute in the same frame the "hidden" state was
               laid out can let the browser collapse both style
               changes into one paint, so the transition never
               visibly plays. Two rAFs guarantee the hidden state
               has actually painted first. */
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                section.setAttribute('data-in-view', 'true');
              });
            });
          } else {
            /* Leaving the viewport in either direction resets the
               animation so it plays again next time it scrolls in. */
            section.removeAttribute('data-in-view');
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(section);
  }

  function initSection(section) {
    if (section.dataset.uspInitialized === 'true') return;
    section.dataset.uspInitialized = 'true';
    initStagger(section);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-usp-showcase]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Theme editor support: re-init when the section is added/reloaded.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();